$('[data-accordion-scroll]').on('click', function(){
    var href = $(this).attr('href');
    var height = $('header').outerHeight();
    var hrefArea = $(href + '-area');
    var position = hrefArea.offset().top - height - 15;
    var hrefDescription = $(href + '-description');
    
    if ($(href).attr('aria-hidden') === 'true') {
        $(this).attr('aria-expanded', 'true');
        $(href).slideDown(300);
        $(href).attr('aria-hidden', 'false');
        $(hrefArea).css({'padding-top':'70px', 'padding-bottom':'70px'});
        $(hrefDescription).addClass('show');
    } else {
        $(this).attr('aria-expanded', 'false');
        $(href).slideUp(300);
        $(href).attr('aria-hidden', 'true');
        $(hrefArea).css({'padding-top':'50px', 'padding-bottom':'50px'});
        $(hrefDescription).removeClass('show');
        $('html, body').animate({scrollTop:position}, 300, 'easeInQuad');
    }
    return false;
});

$('[data-accordion]').on('click', function(){
    var href = $(this).attr('href');
    if ($(href).attr('aria-hidden') === 'true') {
        $(this).attr('aria-expanded', 'true');
        $(href).slideDown(300);
        $(href).attr('aria-hidden', 'false');
    } else {
        $(this).attr('aria-expanded', 'false');
        $(href).slideUp(300);
        $(href).attr('aria-hidden', 'true');
    }
    return false;
});
